export default function calculateCvvChecksum(cvv) {
  // Implements the algorithm described in https://en.wikipedia.org/wiki/Luhn_algorithm
  const rawDigits = cvv.toString().split("");
  const checkNumbers = [];
  for (let i = 0; i < rawDigits.length; i++) {
    const numericDigit = parseInt(rawDigits[i]);
    if ((i + 1) % 2 == 0) {
      checkNumbers.push(
        (numericDigit * 2)
          .toString()
          .split("")
          .map(n => parseInt(n))
          .reduce((a, b) => a + b)
      );
    } else {
      checkNumbers.push(numericDigit);
    }
  }
  return (checkNumbers.reduce((a, b) => a + b) * 9) % 10;
}
